import { $get } from '../axios';

// 新增活动
export const AddAct = params => {
  return $get('/creator/', { act: 'add_activity_pid', ...params, json: 1 });
};

// 编辑活动
export const EditAct = params => {
  return $get('/creator/', { act: 'update_activity_info', ...params, json: 1 });
};

// 编辑活动状态
export const EditActState = params => {
  return $get('/creator/', { act: 'op_activity_state', ...params, json: 1 });
};

// 获取动态列表
export const GetPidList = params => {
  return $get('/creator/', { act: 'get_activity_pid_list', ...params, json: 1 });
};

// 获取单条动态详情
export const GetPidDetail = params => {
  return $get('/creator/', { act: 'get_activity_by_id', ...params, json: 1 });
};
